const formatMonthYear = (date) => {
  const [year, month] = String(date).split('-').map(Number)
  return new Date(year, month - 1, 1).toLocaleString('default', {
    month: 'short',
    year: 'numeric',
  })
}

export default formatMonthYear
